import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

import { SalesOrderPeriod } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPeriodService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.PRE_SALES_REBUILD_DONE ? this.env.APIM_BASE_URL + '/arable-service/' : this.env.API_BASE_URL + '/service/field-advice/secure/';

  getSalesOrderPeriods(cropYear: number) {
    if (this.env.PRE_SALES_REBUILD_DONE) {
      return this.http
        .get<{ salesOrderPeriods: SalesOrderPeriod[] }>(`${this.baseUrl}salesorderperiod?year=${cropYear}`)
        .pipe(map(({ salesOrderPeriods }) => salesOrderPeriods));
    }
    return this.http
      .get<{ salesOrderPeriods: SalesOrderPeriod[] }>(`${this.baseUrl}salesorderperiod/year/${cropYear}`)
      .pipe(map(({ salesOrderPeriods }) => salesOrderPeriods));
  }
}
